import { useSelector } from 'react-redux';
import CoverageNotCompliant from '../CoverageNotCompliant/CoverageNotCompliant';

const CoverageErrors = () => {
  const errors = useSelector(
    (state: any) => state.application?.compliance?.errors,
  );
  return <CoverageNotCompliant errors={errors || []} />;
};

export default CoverageErrors;
